import api from "lib/axios";
import type { ApiEnvelope, PaginatedResult } from "./apiTypes";
import { unwrapData, unwrapList } from "./apiTypes";

export type AdminStudentDevice = {
  id: number;
  device_id: string;
  device_name?: string | null;
  platform: string;
  last_ip?: string | null;
  first_seen_at?: string | null;
  last_login_at?: string | null;
  created_at?: string | null;
};

export type AdminStudentDevicesPayload = {
  max_devices: number;
  used_slots: number;
  remaining_slots: number;
  devices: AdminStudentDevice[];
};

export type AdminStudentLoginLog = {
  id: number;
  phone?: string | null;
  device_id?: string | null;
  device_name?: string | null;
  platform?: string | null;
  ip?: string | null;
  status: string;
  message?: string | null;
  created_at?: string | null;
};

export const adminStudentDevicesService = {
  async devices(studentId: string | number): Promise<AdminStudentDevicesPayload> {
    const response = await api.get<ApiEnvelope<{ data: AdminStudentDevicesPayload }>>(
      `/mcp/students/${studentId}/devices`,
      { meta: { toastSuccess: false } }
    );
    return unwrapData<AdminStudentDevicesPayload>(response.data) as AdminStudentDevicesPayload;
  },

  async removeDevice(
    studentId: string | number,
    deviceRowId: string | number
  ): Promise<AdminStudentDevicesPayload> {
    const response = await api.delete<ApiEnvelope<{ data: AdminStudentDevicesPayload }>>(
      `/mcp/students/${studentId}/devices/${deviceRowId}`,
      { meta: { toastSuccess: false } }
    );
    return unwrapData<AdminStudentDevicesPayload>(response.data) as AdminStudentDevicesPayload;
  },

  async loginLogs(
    studentId: string | number,
    params?: { page?: number; limit?: number; status?: string }
  ): Promise<PaginatedResult<AdminStudentLoginLog>> {
    const response = await api.get<ApiEnvelope<PaginatedResult<AdminStudentLoginLog>>>(
      `/mcp/students/${studentId}/login-logs`,
      { params, meta: { toastSuccess: false } }
    );
    return unwrapList<AdminStudentLoginLog>(response.data);
  },
};
